import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
// Styles //
import "./videoInterna.scss";

const VideoInterna = (props: ReferenciaContenido) => {
    const { redireccionBoton, video } = props;
    
    return (
        <>
            {redireccionBoton && (
                <div className={`m-videoInterna`}>
                    <div className="videoInterna-item">
                        <div className="videoInterna-item__video">
                            <iframe
                                className="video"
                                src={redireccionBoton}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
            {video && (
                <div className={`m-videoInterna`}>
                    <div className="videoInterna-item">
                        <div className="videoInterna-item__video">
                            <video controls>
                                <source src={video.fields.file.url} type={video.fields.file.contentType} />
                            </video>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoInterna;
